import { PageUrl } from '../../../../pages/utils/page-url';
import type { LinksToRetrieve } from '../types';

export const links: LinksToRetrieve[] = [
    {
        id: 1,
        url: { action: PageUrl.SEARCH_SHOW, args: ['cgid', 'classes'] },
    },
    {
        id: 2,
        url: { action: PageUrl.STORES_FIND },
    },
    {
        id: 3,
        url: { action: PageUrl.SEARCH_SHOW, args: ['cgid', 'perks-buy-more-save-more'] },
    },
    {
        id: 4,
        url: { action: PageUrl.GIFT_REGISTRY_START },
    },
    {
        id: 5,
        url: { action: PageUrl.SEARCH_SHOW, args: ['cgid', 'CAT-GIFT-1'] },
    },
    {
        id: 6,
        url: { action: PageUrl.WISHLIST },
    },
    {
        id: 7,
        url: { action: PageUrl.SEARCH_SHOW, args: ['cgid', 'recipes'] },
    },
    {
        id: 8,
        url: { action: PageUrl.TURN_TO },
    },
];
